export const HomeTabData = {
  hot: [
    {
      name: "HEYVIP Super Ace",
      image: "/assets/Hot/darkIcon.webp",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-027",
      platFormCode: "JILI",
    },
    {
      name: "Fortune Gems Legend",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-204",
      platFormCode: "JILI",
      image: "/assets/Hot/darkIcon (1).webp",
    },
    {
      name: "Fortune Garuda 500",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-193",
      platFormCode: "JILI",
      image: "/assets/Hot/darkIcon (2).webp",
    },
    {
      name: "Super Ace Deluxe",
      image: "/assets/Hot/darkIcon (3).webp",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-102",
      platFormCode: "JILI",
    },
    {
      name: "Boxing King",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-031",
      platFormCode: "JILI",
      image: "/assets/Hot/darkIcon (4).webp",
    },
    {
      name: "Fortune Gems 3",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-096",
      platFormCode: "JILI",
      image: "/assets/Hot/darkIcon (5).webp",
    },
    {
      name: "Fortune Gems 2",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-076",
      platFormCode: "JILI",
      image: "/assets/Hot/darkIcon (6).webp",
    },
    {
      name: "Fortune Gems",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-043",
      platFormCode: "JILI",
      image: "/assets/Hot/darkIcon (7).webp",
    },
    {
      name: "Money Coming",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-029",
      platFormCode: "JILI",
      image: "/assets/Hot/darkIcon (8).webp",
    },
    {
      name: "HEYVIP Super Elements",
      gameType: "SLOT",
      casinoType: "FC-SLOT-033",
      platFormCode: "FC",
      image: "/assets/Hot/darkIcon (9).webp",
    },
    {
      name: "HEYVIP Pirate Legends",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-037",
      platFormCode: "YESBINGO",
      image: "/assets/Hot/darkIcon (10).webp",
    },
    {
      name: "Aviator",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-001",
      platFormCode: "SPRIBE",
      image: "/assets/Hot/darkIcon (11).webp",
    },
    {
      name: "Crazy Time",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-006",
      platFormCode: "EVOLUTION",
      image: "/assets/Hot/darkIcon (12).webp",
    },
    {
      name: "Sexy Baccarat",
      gameType: "LIVE",
      casinoType: "MX-LIVE-001",
      platFormCode: "SEXYBCRT",
      image: "/assets/Hot/darkIcon (13).webp",
    },
    {
      name: "Wild Bounty Showdown",
      gameType: "SLOT",
      casinoType: "PG-SLOT-105",
      platFormCode: "PG",
      image: "/assets/Hot/darkIcon (14).webp",
    },
    {
      name: "Magic Ace Wild Lock",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-127",
      platFormCode: "JDB",
      image: "/assets/Hot/darkIcon (15).webp",
    },
  ],
  sports: [
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKET",
      name: "9wickets",
      src: "/assets/Platform/icon-9w-cricket.png",
      alt: "icon-9w-cricket",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "Velki",
      src: "/assets/Icon/velki-favicon.ico",
      alt: "icon-cricket",
    },

    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "Sportsbook",
      src: "/assets/NewIcon/darkIcon.png",
      alt: "icon-cricket",
      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "BTI",
      src: "/assets/NewIcon/provider-sbtech.png",
      alt: "icon-cricket",
      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "InSports",
      src: "/assets/NewIcon/provider-awcv2_insports.png",
      alt: "icon-cricket",
      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "CMD",
      src: "/assets/NewIcon/provider-cmd.png",
      alt: "icon-cricket",
      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "Pinnacle",
      src: "/assets/NewIcon/provider-awcv2_pinnacle.png",
      alt: "icon-cricket",
      gameType: "SPORTS",
      casinoType: "PINNACLE-SPORTS-001",
      platFormCode: "PINNACLE",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "HorseBook",
      src: "/assets/NewIcon/icon-horsebook.png",
      alt: "icon-cricket",
      gameType: "LIVE",
      casinoType: "HRB-LIVE-001",
      platFormCode: "HORSEBOOK",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "SBO",
      src: "/assets/NewIcon/provider-sbov2.png",
      alt: "icon-cricket",

      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
  ],
  casino: [
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "EVOLUTION",
      name: "EVO",
      src: "../assets/Platform/provider-evo.png",
      alt: "provider-awcv2_evolution",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "SEXYBCRT",
      name: "SEXY",
      src: "../assets/Platform/provider-awcmsexy.png",
      alt: "provider-awcmsexy",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "PP",
      name: "PP",
      src: "../assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "PT",
      name: "PT",
      src: "../assets/Platform/provider-awcmpt.png",
      alt: "provider-awcmpt",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "DREAMGAMING",
      name: "DG",
      src: "../assets/Platform/provider-awcmdg.png",
      alt: "provider-awcmdg",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "HOTROAD",
      name: "HotRoad",
      src: "../assets/Platform/provider-awcmhotroad.png",
      alt: "provider-awcv2_hotroad",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "VIACASINO",
      name: "VIA",
      src: "../assets/Platform/provider-awcmvia.png",
      alt: "provider-awcmvia",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "CREEDROOMZ",
      name: "CreedRoomz",
      src: "../assets/Platform/provider-awcv2_creedroomz.png",
      alt: "provider-awcv2_creedroomz",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "WINFINITY",
      name: "WINFINITY",
      src: "../assets/Platform/provider-awcv2_winfinity.png",
      alt: "provider-awcv2_winfinity",
    },
  ],
  slots: [
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PG",
      name: "PG",
      src: "../assets/Platform/provider-awcv2_pg.png",
      alt: "provider-awcv2_pg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "JDB",
      name: "JDB",
      src: "../assets/Platform/jdb.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "FC",
      name: "FC",
      src: "../assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "SPADE",
      name: "SG",
      src: "../assets/Platform/provider-awcmsg.png",
      alt: "provider-awcmsg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "FASTSPIN",
      name: "FASTSPIN",
      src: "../assets/Platform/provider-awcmfastspin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmfastspin",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PP",
      name: "PP",
      src: "../assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "YESBINGO",
      name: "YELLOW BAT",
      src: "../assets/Platform/provider-awcv2_yesbingo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yesbingo",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "BTG",
      name: "BTG",
      src: "../assets/Platform/provider-awcv2_btg.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_btg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "NLC",
      name: "NLC",
      src: "../assets/Platform/provider-awcv2_nlc.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_nlc",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "DRAGOONSOFT",
      name: "Dragoonsoft",
      src: "../assets/Platform/provider-awcv2_dragoonsoft.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_dragoonsoft",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "RT",
      name: "RT",
      src: "../assets/Platform/provider-awcmrt.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmrt",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PT",
      name: "PT",
      src: "../assets/Platform/provider-awcmpt.png",
      alt: "provider-awcmpt",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "NETENT",
      name: "NETENT",
      src: "../assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
      alt: "provider-netent",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PLAY8",
      name: "P8",
      src: "../assets/Platform/provider-awcmp8.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmp8",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "Joker",
      name: "Joker",
      src: "../assets/Platform/provider-joker.png?v=1772072361392&source=mcdsrc",
      alt: "provider-joker",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PLAYNGO",
      name: "PNG",
      src: "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-playngo",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "CG",
      name: "CG",
      src: "../assets/Platform/provider-awcmcg.png",
      alt: "provider-awcmcg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "YL",
      name: "YL",
      src: "../assets/Platform/yl.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "RELAX",
      name: "RELAX",
      src: "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "OCTOPLAY",
      name: "OCTOPLAY",
      src: "../assets/Platform/provider-awcv2_octoplay.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_octoplay",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "ACEWIN",
      name: "ACEWiN",
      src: "../assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_acewin",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "HACKSAW",
      name: "HACKSAW",
      src: "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_hacksaw",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "JJ",
      name: "JJ",
      src: "../assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_jj",
    },

    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "YGGDRASIL",
      name: "YGGDRASIL",
      src: "../assets/Platform/provider-awcv2_yggdrasil.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yggdrasil",
    },
  ],
  crash: [
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "SPRIBE",
      name: "JDBASPRIBE",
      src: "../assets/Platform/provider-jdbaspribe.png?v=1772072361392&source=mcdsrc",
      alt: "provider-jdbaspribe",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "JDB",
      name: "JDB",
      src: "../assets/Platform/jdb.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "FC",
      name: "FC",
      src: "../assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "PP",
      name: "PP",
      src: "../assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },

    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "CG",
      name: "CG",
      src: "../assets/Platform/provider-awcmcg.png",
      alt: "provider-awcmcg",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "YL",
      name: "YL",
      src: "../assets/Platform/darkIcon.png",
    },

    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "RELAX",
      name: "RELAX",
      src: "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "CRASH88",
      name: "CRASH88",
      src: "../assets/Platform/provider-awcv2_crash88.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_crash88",
    },
  ],
  table: [
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },
    // {
    //   categoryType: "VENDOR",
    //   gameType: 256,
    //   vendor: "RICH88",
    //   name: "RICH88",
    //   src: "../assets/Platform/provider-rich88.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-rich88",
    // },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "SPRIBE",
      name: "JDBASPRIBE",
      src: "../assets/Platform/provider-jdbaspribe.png?v=1772072361392&source=mcdsrc",
      alt: "provider-jdbaspribe",
    },

    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "NETENT",
      name: "NETENT",
      src: "../assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
      alt: "provider-netent",
    },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "PT",
      name: "PT",
      src: "../assets/Platform/provider-awcmpt.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmpt",
    },
    // {
    //   categoryType: "VENDOR",
    //   gameType: 256,
    //   vendor: "PLAYNGO",
    //   name: "PNG",
    //   src: "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-playngo",
    // },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "PG",
      name: "PG",
      src: "../assets/Platform/provider-awcv2_pg.png",
      alt: "provider-awcv2_pg",
    },

    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "RELAX",
      name: "RELAX",
      src: "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "HACKSAW",
      name: "HACKSAW",
      src: "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_hacksaw",
    },
  ],
  fishing: [
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "JDB",
      name: "JDB",
      src: "../assets/Platform/jdb.png?v=1770791064378",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "FC",
      name: "FC",
      src: "../assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },

    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "FASTSPIN",
      name: "FASTSPIN",
      src: "../assets/Platform/provider-awcmfastspin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmfastspin",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "SPADE",
      name: "SPADE",
      src: "../assets/Platform/provider-awcmsg.png",
      alt: "provider-awcmsg",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "YESBINGO",
      name: "YELLOW BAT",
      src: "../assets/Platform/provider-awcv2_yesbingo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yesbingo",
    },

    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "ACEWIN",
      name: "ACEWiN",
      src: "../assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_acewin",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "JJ",
      name: "JJ",
      src: "../assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_jj",
    },
    // {
    //   categoryType: "VENDOR",
    //   gameType: 8,
    //   vendor: "GTF",
    //   name: "GTF",
    //   src: "../assets/Platform/provider-awcv2_gtf.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-awcv2_gtf",
    // },
  ],
  arcade: [
    // {
    //   categoryType: "VENDOR",
    //   gameType: 1024,
    //   vendor: "RICH88",
    //   name: "RICH88",
    //   src: "../assets/Platform/provider-rich88.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-rich88",
    // },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "JDB",
      name: "JDB",
      src: "../assets/Platform/jdb.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "FC",
      name: "FC",
      src: "../assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },

    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "PP",
      name: "PP",
      src: "../assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },

    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "PG",
      name: "PG",
      src: "../assets/Platform/provider-awcv2_pg.png",
      alt: "provider-awcv2_pg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },

    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "CG",
      name: "CG",
      src: "../assets/Platform/provider-awcmcg.png",
      alt: "provider-awcmcg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "YL",
      name: "YL",
      src: "../assets/Platform/darkIcon.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "RELAX",
      name: "RELAX",
      src: "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    // {
    //   categoryType: "VENDOR",
    //   gameType: 1024,
    //   vendor: "HACKSAW",
    //   name: "HACKSAW",
    //   src: "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-awcv2_hacksaw",
    // },
  ],
  lottery: [
    {
      categoryType: "VENDOR",
      gameType: 64,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 64,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },
    {
      categoryType: "VENDOR",
      gameType: 64,
      vendor: "YESBINGO",
      name: "YELLOW BAT",
      src: "../assets/Platform/provider-awcv2_yesbingo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yesbingo",
    },
  ],
};
export const HomeFooterPlatform = [
  {
    name: "saba",
    image: "/assets/Footer/provider-saba.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "jdb",
    image: "/assets/Footer/provider-jdb.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "jdbaspribe",
    image:
      "/assets/Footer/provider-jdbaspribe.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "cq9",
    image: "/assets/Footer/provider-cq9.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "pg",
    image: "/assets/Footer/provider-pg.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "evo",
    image: "/assets/Footer/provider-evo.webp?v=1772072361392&source=mcdsrc",
  },

  {
    name: "netent",
    image: "/assets/Footer/provider-netent.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "png",
    image: "/assets/Footer/provider-png.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "rich88",
    image: "/assets/Footer/provider-rich88.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "worldmatch",
    image:
      "/assets/Footer/provider-worldmatch.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmsexy",
    image:
      "/assets/Footer/provider-awcmsexy.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmrt",
    image: "/assets/Footer/provider-awcmrt.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmsg",
    image: "/assets/Footer/provider-awcmsg.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmkm",
    image: "/assets/Footer/provider-awcmkm.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmjili",
    image:
      "/assets/Footer/provider-awcmjili.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmp8",
    image: "/assets/Footer/provider-awcmp8.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmfc",
    image: "/assets/Footer/provider-awcmfc.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmhotroad",
    image:
      "/assets/Footer/provider-awcmhotroad.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmpp",
    image: "/assets/Footer/provider-awcmpp.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmpt",
    image: "/assets/Footer/provider-awcmpt.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "horsebook",
    image: "/assets/Footer/icon-horsebook.svg?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmfastspin",
    image:
      "/assets/Footer/provider-awcmfastspin.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmyesbingo",
    image:
      "/assets/Footer/provider-awcmyesbingo.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "sv388",
    image: "/assets/Footer/icon-sv388.svg?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcme1sport",
    image:
      "/assets/Footer/provider-awcme1sport.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmrwb",
    image: "/assets/Footer/provider-awcmrwb.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmpinnacle",
    image:
      "/assets/Footer/provider-awcmpinnacle.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "nst",
    image: "/assets/Footer/icon-nst.svg?v=1772072361392&source=mcdsrc",
  },
];
export const HomeFavourite = [
  {
    name: "HEYVIP Super Ace",
    image: "/assets/Hot/image_366966.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
  },
  {
    name: "Super Ace",
    image: "/assets/Hot/image_331475.webp",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-142",
    platFormCode: "JILI",
  },
  {
    name: "Super Ace Deluxe",
    image: "/assets/Hot/image_331519.webp",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-102",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Gems 500",
    image: "/assets/Hot/image_331484.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-204",
  },
  {
    name: "Boxing King",
    image: "/assets/Hot/image_331509.webp",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-031",
    platFormCode: "JILI",
  },
  {
    name: "Wild Bounty Showdown",
    image: "/assets/Hot/image_331611.webp",
    gameType: "SLOT",
    casinoType: "PG-SLOT-105",
    platFormCode: "PG",
  },
  {
    name: "Magic Ace WILD LOCK",
    image: "/assets/Hot/image_331628.webp",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-127",
    platFormCode: "JDB",
  },
];
export const filtercasion = [
  {
    name: "PT",
    image: "../assets/Platform/provider-awcmpt.png",
  },
  {
    name: "VIACASINO",
    image: "../assets/Platform/provider-awcmvia.png",
  },
  {
    name: "PP",
    image: "../assets/Platform/provider-awcmpp.png",
  },
  {
    name: "EVOLUTION",
    image: "../assets/Platform/provider-evo.png",
  },
  {
    name: "SEXYBCRT",
    image: "../assets/Platform/provider-awcmsexy.png",
  },
  {
    name: "HOTROAD",
    image: "../assets/Platform/provider-awcmhotroad.png",
  },
  {
    name: "DREAMGAMING",
    image: "../assets/Platform/provider-awcmdg.png",
  },
  {
    name: "CREEDROOMZ",
    image: "../assets/Platform/provider-awcv2_creedroomz.png",
  },
  {
    name: "WINFINITY",
    image: "../assets/Platform/provider-awcv2_winfinity.png",
  },
];

export const filterslot = [
  {
    name: "PG",
    image: "../assets/Platform/provider-awcv2_pg.png",
  },
  {
    name: "CG",
    image: "../assets/Platform/provider-awcmcg.png",
  },

  {
    name: "DRAGOONSOFT",
    image: "../assets/Platform/provider-dragoonsoft.png",
  },
  {
    name: "PP",
    image: "../assets/Platform/provider-awcmpp.png",
  },
  {
    name: "PT",
    image: "../assets/Platform/provider-awcmpt.png",
  },
  {
    name: "KINGMAKER",
    image:
      "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "RT",
    image: "../assets/Platform/provider-awcmrt.png",
  },
  {
    name: "BTG",
    image:
      "../assets/Platform/provider-awcv2_btg.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JILI",
    image: "../assets/Platform/provider-awcmjili.png",
  },
  {
    name: "NETENT",
    image:
      "../assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JDB",
    image: "../assets/Platform/provider-jdb.png",
  },
  {
    name: "FC",
    image: "../assets/Platform/provider-awcmfc.png",
  },
  {
    name: "NLC",
    image: "../assets/Platform/provider-nlc.png",
  },
  {
    name: "FASTSPIN",
    image: "../assets/Platform/provider-awcmfastspin.png",
  },
  {
    name: "YGGDRASIL",
    image:
      "../assets/Platform/provider-awcv2_yggdrasil.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "SPADE",
    image: "../assets/Platform/provider-awcmsg.png",
  },
  {
    name: "JJ",
    image:
      "../assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "Joker",
    image: "../assets/Platform/provider-joker.png",
  },
  {
    name: "OCTOPLAY",
    image: "../assets/Platform/provider-awcv2_octoplay.png",
  },
  {
    name: "PLAYNGO",
    image:
      "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  },

  {
    name: "ACEWIN",
    image:
      "../assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "PLAY8",
    image: "../assets/Platform/provider-awcmp8.png",
  },
  {
    name: "RELAX",
    image:
      "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "YESBINGO",
    image: "../assets/Platform/provider-awcmyesbingo.png",
  },
  {
    name: "YL",
    image: "../assets/Platform/yl.png",
  },
];

export const filtertable = [
  {
    image: "../assets/Platform/provider-awcmjili.png",
    name: "JILI",
  },
  {
    name: "HACKSAW",
    image:
      "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
  },
  {
    image: "../assets/Platform/provider-awcmkm.png",
    name: "KINGMAKER",
  },
  {
    name: "NETENT",
    image:
      "../assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "PT",
    image: "../assets/Platform/provider-awcmpt.png",
  },
  // {
  //   name: "PLAYNGO",
  //   image:
  //     "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  // },
  {
    name: "RELAX",
    image:
      "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   image: "../assets/Platform/provider-rich88.png",
  //   name: "RICH88",
  // },
  {
    name: "PG",
    image: "../assets/Platform/provider-awcv2_pg.png",
  },
  {
    image: "../assets/Platform/provider-jdbaspribe.png",
    name: "SPRIBE",
  },
];

export const filtercrash = [
  {
    image: "../assets/Platform/provider-jdbaspribe.png",
    name: "SPRIBE",
  },
  {
    name: "JDB",
    image: "../assets/Platform/provider-jdb.png",
  },
  {
    name: "YL",
    image: "../assets/Platform/yl.png",
  },
  {
    name: "RELAX",
    image:
      "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  {
    image: "../assets/Platform/provider-awcmjili.png",
    name: "JILI",
  },
  {
    name: "PP",
    image: "../assets/Platform/provider-awcmpp.png",
  },
  {
    name: "CG",
    image: "../assets/Platform/provider-awcmcg.png",
  },
  // {
  //   image: "../assets/Platform/provider-rich88.png",
  //   name: "RICH88",
  // },
  // {
  //   name: "Joker",
  //   image: "../assets/Platform/provider-joker.png",
  // },
  // {
  //   name: "SMARTSOFT",
  //   image:
  //     "../assets/Platform/provider-awcv2_smartsoft.png?v=1772072361392&source=mcdsrc",
  // },
  {
    image: "../assets/Platform/provider-awcmkm.png",
    name: "KINGMAKER",
  },
  // {
  //   name: "PLAYNGO",
  //   image:
  //     "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  // },
  {
    image: "../assets/Platform/provider-awcmfc.png",
    name: "FC",
  },
  {
    image:
      "../assets/Platform/provider-awcv2_crash88.png?v=1772072361392&source=mcdsrc",
    name: "CRASH88",
  },
];

export const filterfishing = [
  {
    name: "JILI",
    image: "../assets/Platform/provider-awcmjili.png",
  },
  {
    name: "SPADE",
    image: "../assets/Platform/provider-awcmsg.png",
  },
  {
    name: "FC",
    image: "../assets/Platform/provider-awcmfc.png",
  },
  {
    name: "YESBINGO",
    image: "../assets/Platform/provider-awcmyesbingo.png",
  },
  {
    name: "ACEWIN",
    image:
      "../assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JDB",
    image: "../assets/Platform/provider-jdb.png",
  },
  {
    name: "FASTSPIN",
    image:
      "../assets/Platform/provider-awcmfastspin.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JJ",
    image:
      "../assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   name: "JOKER",
  //   image: "../assets/Platform/provider-joker.png",
  // },
  // {
  //   name: "GTF",
  //   image:
  //     "../assets/Platform/provider-awcv2_gtf.png?v=1772072361392&source=mcdsrc",
  // },
];

export const filterarcade = [
  {
    image: "../assets/Platform/provider-awcv2_pg.png",
    name: "PG",
  },
  {
    name: "JILI",
    image: "../assets/Platform/provider-awcmjili.png",
  },
  {
    name: "PP",
    image: "../assets/Platform/provider-awcmpp.png",
  },
  {
    name: "KINGMAKER",
    image:
      "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "CG",
    image: "../assets/Platform/provider-awcmcg.png",
  },
  {
    image: "../assets/Platform/provider-jdb.png",
    name: "JDB",
  },
  {
    image: "../assets/Platform/provider-awcmfc.png",
    name: "FC",
  },
  // {
  //   name: "HACKSAW",
  //   image:
  //     "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
  // },
  {
    image: "../assets/Platform/provider-awcmyl.png",
    name: "YL",
  },
  {
    name: "RELAX",
    image:
      "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   image: "../assets/Platform/provider-rich88.png",
  //   name: "RICH88",
  // },
];

export const filterlotto = [
  {
    image: "../assets/Platform/provider-awcmjili.png",
    name: "JILI",
  },

  {
    name: "YESBINGO",
    image: "../assets/Platform/provider-awcmyesbingo.png",
  },
  {
    name: "KINGMAKER",
    image:
      "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   name: "PLAYNGO",
  //   image:
  //     "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  // },
  // {
  //   name: "HACKSAW",
  //   image:
  //     "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
  // },
  // {
  //   name: "Joker",
  //   image: "../assets/Platform/provider-joker.png",
  // },
  // {
  //   name: "RICH88",
  //   image: "../assets/Platform/provider-rich88.png",
  // },
];

export const HomeIcon = {
  sports: `../assets/Icon/icon-sport.png`,
  casino: "../assets/Icon/icon-casino.png",
  slots: "../assets/Icon/icon-slot.png",
  table: "../assets/Icon/icon-table.png",
  crash: "../assets/Icon/icon-crash.png",
  fishing: "../assets/Icon/icon-fish.png",
  arcade: "../assets/Icon/icon-arcade.png",
  lotto: "../assets/Icon/icon-lottery.png",
};
